import { Component, Input } from '@angular/core';

/**
 * Resumo de totais do Passo 1 ("Itens"): contagem de itens, peso total, valor total
 * (parcial se houver fator financeiro) e pontuação (pedidos-cadastro.component.html:1169-1189).
 * Read-only — nenhum @Output, nenhuma lógica de cálculo (os valores já vêm prontos do pai).
 */
@Component({
  selector: 'app-pedido-itens-resumo',
  standalone: false,
  templateUrl: './pedido-itens-resumo.component.html',
  styleUrls: ['./pedido-itens-resumo.component.scss']
})
export class PedidoItensResumoComponent {
  @Input() produtosAdicionadosLength = 0;
  @Input() valorTotalPesoProdutosAdicionados = 0;
  @Input() valorParcialProdutosAdicionados = 0;
  @Input() exibirFatorFinanceiro = false;
  @Input() exibirPontuacao = false;
  @Input() valorTotalPontuacaoProdutosAdicionados = 0;
}
